import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { Sda } from 'src/app/models/centrex/sda';
import { Organization } from 'src/app/models/organization';
import { OrganizationsService } from '../organizations.service';
import { ServiceBase } from '../service-base';

@Injectable({
    providedIn: 'root',
})
export class SdaService extends ServiceBase {
    constructor(private http: HttpClient, private organizationsServices: OrganizationsService) {
        super();
    }

    getSdas(): Observable<Sda[]> {
        const httpOptions = {
            headers: new HttpHeaders().set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.get<Sda[]>(`${this.baseUrl}/api/sdas`, httpOptions);
    }

    getSda(sdaId: string): Observable<Sda> {
        const httpOptions = {
            headers: new HttpHeaders().set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.get<Sda>(`${this.baseUrl}/api/sdas/${sdaId}`, httpOptions);
    }

    addSda(sda: Sda, globalNotification = true): Observable<Sda> {
        const httpOptions = {
            headers: new HttpHeaders()
                .set('Content-Type', 'application/json')
                .set('global-notification', String(globalNotification))
                .set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.post<Sda>(`${this.baseUrl}/api/sdas`, sda, httpOptions);
    }

    updateSda(sda: Sda): Observable<Sda> {
        const httpOptions = {
            headers: new HttpHeaders().set('Content-Type', 'application/json').set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.patch<Sda>(`${this.baseUrl}/api/sdas/${sda.id}`, sda, httpOptions);
    }

    deleteSda(sdaId: string) {
        const httpOptions = {
            headers: new HttpHeaders().set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.delete<Sda>(`${this.baseUrl}/api/sdas/${sdaId}`, httpOptions);
    }
}
